import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js';

// import './assets/js/registerHooks.js';
import './assets/js/rem.js';
import 'vant/lib/index.css';

// 解决移动端300ms点击穿透
import fastclick  from 'fastclick';
fastclick.attach(document.body);

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
